export default __webpack_public_path__ + "static/media/logoPagesRS.d5a0c372.png";